module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE0SURBVHgBrVSBbcIwEPxUHSAb1J2AbNB0g47ABs0GZYVOEHWCqhMkGxQmCEwATBDulTM4xhAr5qSTQ3w5H/63RSLQ930OVuCHPAowq8FfcA+WkgqYGLDjuAIbSQVTrvicM62RuWC63jVh2lrmgilr791k2mcrxKCVVeELWIA5f7+6H2RZdoD+G4+6z2uMW3IHrjHfZlxRN78FjzoBHijYyu1/YRd1+Qb+6WSRvPmXhT7P3cHN71KMaTj2SDHGN183v51jfNfQEekZ7yTOcBkyfApoWxmqHwPVbfwuCZkaGXouBtp+C/9lyLSUIe0I7MsRmDD350KmCyY4m2kxZDhBTaAgqi2mTAtrqoXA8M/07+AP2PBOMNRvfNMr8HRVrGoTupSd1rOX93LK1FBcRugqe9e6OAHC7kOssCISFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/star-icon.png
// module id = 66
// module chunks = 0